import moment from 'moment';

export const DateFormatter = () => {
  const formatDate = (date, format = 'DD.MM.YYYY') => {
    if (!date) return null;

    if (moment.isMoment(date) || date instanceof Date) {
      return moment(date).format(format);
    }

    const momentDate = moment(date, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD']);
    if (!momentDate.isValid()) {
      return null;
    }

    return momentDate.format(format);
  };

  const formatTimestamp = (date) => {
    if (!date) return null;

    const parsed = moment(date, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]);
    if (!parsed.isValid()) return null;

    return parsed.utc(true).unix();
  };

  return {
    formatDate,
    formatTimestamp,
  };
};
